export enum AccionSolicitud {
  Aprobar = 0,
  Rechazar = 1
}
